import axios from 'axios';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchRepatriationsTransactionsDelete = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'deleteRepatriationsTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.delete(serviceUrl, {
    data: {
      description: payload.params.description,
      transactionId: payload.params.transactionId,
    },
  });
};

export default apiFetchRepatriationsTransactionsDelete;
